var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"big-number text-warning"},[_vm._v(_vm._s(_vm.theDistance)+" km")])])
}
var staticRenderFns = []

export { render, staticRenderFns }